import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import enTranslation from '@/operator/public/locales/en/common.json';
import esTranslation from '@/operator/public/locales/es/common.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: enTranslation },
        es: { translation: esTranslation },
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
});

export default i18n;
